import React from "react";

export function AboutPage() {
  return (
    <div className="message">
          <div>
      <p>
           Data Sources include FAA and NOAA/NWS (public domain).
      </p>
      <br />
      <p>
           This tool is provided for informational and educational purposes only
           and is not intended for operational flight planning.
      </p>
      <p>
           No warranty is made regarding the accuracy, completeness, or 
           timeliness of the data or calculations.
      </p>
      <br />
      <p> 
           Always consult official FAA publications, weather briefings, and certified sources before making 
           any preflight planning decisions.
        </p>
        </div>
    </div>
  );
}

export default AboutPage;